import { IPhuHuynhSelectRequest } from "../../../models/request/phu-huynh/IPhuHuynhSelectRequest";
import { IPhuHuynhItemResponse } from "../../../models/response/hoc-sinh/IPhuHuynhItemReponse";
import { ts_phuhuynh } from "../../../models/response/hoc-sinh/ts_phuhuynh";
import IGenericActionType from "../IGenericActionType";
import { generateActionTypeIds } from "../generateActionTypeIds";

export const objCrmPhuHuynhDefine = {
    LOAD_START: {} as any,
    LOAD_SUCCESS: [] as IPhuHuynhItemResponse[], 
    LOAD_ERROR: "",
    // UPDATE_ADVISOR_START: "",
    // UPDATE_ADVISOR_SUCCESS: {},
    // UPDATE_ADVISOR_ERROR: "",
     SEARCH_START: [] as any,
     SEARCH_SUCCESS: [] as ts_phuhuynh[], // Thay đổi `any` thành kiểu dữ liệu cụ thể nếu có
     SEARCH_ERROR: "",
     GET_BY_ID_START: "",
     GET_BY_ID_SUCCESS: {},
     GET_BY_ID_ERROR: "",
     CHANGE_SELECTED_IDS: [] as number[], // Định nghĩa đúng loại cho payload
};

// Tạo action type IDs cho các action của HocSinh
export const eCrmPhuHuynhActionTypeIds = generateActionTypeIds(objCrmPhuHuynhDefine, "CRM_PHU_HUYNH");

// Định nghĩa type cho action types
export type ICrmPhuHuynhActionTypes = IGenericActionType<typeof objCrmPhuHuynhDefine, "CRM_PHU_HUYNH">;
